import { ChangeDetectionStrategy, Component, computed } from '@angular/core';
import { isDateRangePair } from '@nk/utils-lib';
import { DateRangeComponent } from '../../date-range/date-range.component';
import { EntityWithUuid, NkCardListItemAbstractComponent } from '../card-list.utils';

import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'nk-card-list-item-date-range',
  imports: [TranslateModule, DateRangeComponent],
  templateUrl: './card-list-item-date-range.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardListItemDateRangeComponent<
  Entity extends EntityWithUuid,
> extends NkCardListItemAbstractComponent<Entity> {
  public dates = computed(() => {
    const value = this.valueSignal();
    if (typeof value !== 'undefined' && value !== null) {
      const dateRange = value.entity[value.prop];
      if (isDateRangePair(dateRange)) {
        return { fromDate: dateRange[0], toDate: dateRange[1] };
      }
    }
    return null;
  });
}
